// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--vsDRR";
export var logo = "Footer-module--logo--3Y3gK";
export var nav = "Footer-module--nav--1oo0B";
export var socials = "Footer-module--socials--2RVfZ";